import { SelectCombobox } from 'components/combobox';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useCompaniesQuery } from 'types/generated/graphql';

export interface Company {
  id: string;
  subjectId: string;
  name?: string;
}

interface CompanySelectProps {
  selectedTenantSubjectId: string | null;
  onSelect: (tenantSubjectId: string | null) => void;
  label?: string;
}

/**
 * Reusable Company select component
 * Fetches companies and allows selection
 */
export function CompanySelect({
  selectedTenantSubjectId,
  onSelect,
  label,
}: CompanySelectProps) {
  const { t } = useTranslation();
  const { data } = useCompaniesQuery();
  const companies = (data?.companies ?? []) as Company[];

  const selectedCompany =
    companies.find((c) => c.subjectId === selectedTenantSubjectId) ?? null;

  return (
    <Wrapper>
      <SelectCombobox
        items={companies}
        value={selectedCompany}
        onChange={(company) => onSelect(company?.subjectId ?? null)}
        getItemLabel={(company) => (company ? company.name || company.id : '')}
        getItemValue={(company) => company.subjectId}
        label={label || t('Events.Filter.Courier.Company')}
        searchPlaceholder={t('Events.Filter.SearchCompany')}
        emptyMessage={t('Events.Filter.NoCompanies')}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 250px;
`;
